import { CompanyDetailsCard } from '../components/CompanyDetailsCard';
import { CreditsCard } from '../components/CreditsCard';
import { companyCopy, creditsCopy } from '../copy';
import { useTenant, useTenantSettings, useUpdateSettings } from '../hooks';
import { SettingsSaveError, SettingsSection, TabColumn } from './TabLayout';

/**
 * Tabblad Bedrijf: wat klanten, rapporten en facturen over het bedrijf zeggen,
 * en - voor wie instellingen beheert - wat er gebeurt als het tegoed opraakt.
 *
 * Onder elkaar: de gegevens zijn een lang formulier, het tegoed een korte kaart
 * over iets anders. De link naar "Ingeschreven als" in de gegevens opent het
 * tabblad Rapport (`SettingsPage`).
 */
export function CompanyTab({ canManage }: { canManage: boolean }) {
    const tenant = useTenant();

    return (
        <TabColumn>
            <SettingsSection
                title={companyCopy.title}
                query={tenant}
                onRetry={() => void tenant.refetch()}
            >
                {tenant.data ? (
                    <CompanyDetailsCard tenant={tenant.data} canManage={canManage} />
                ) : null}
            </SettingsSection>

            {canManage ? <Credits /> : null}
        </TabColumn>
    );
}

/** Wat er gebeurt als de keuringen op zijn, en de waarschuwing: alleen voor wie instellingen beheert, en dus alleen dan opgevraagd. */
function Credits() {
    const settings = useTenantSettings();
    const updateSettings = useUpdateSettings();

    return (
        <SettingsSection
            title={creditsCopy.title}
            query={settings}
            onRetry={() => void settings.refetch()}
        >
            {settings.data ? (
                <>
                    <CreditsCard
                        settings={settings.data}
                        disabled={updateSettings.isPending}
                        saving={updateSettings.isPending}
                        error={updateSettings.error}
                        onSave={(patch, done) => updateSettings.mutate(patch, { onSuccess: done })}
                    />
                    <SettingsSaveError error={updateSettings.error} />
                </>
            ) : null}
        </SettingsSection>
    );
}
